export default __webpack_public_path__ + "static/media/02.ef269b22.jpg";